import $ from 'jquery';
import _ from 'lodash-es';

export default (container = document) => {
  $('[data-rte-staggered-articles]', container).each((i, articles_container) => {
    const $articles_container = $(articles_container);
    const main_index = $articles_container.data('main');
    const $articles = $articles_container.children('[data-rte-staggered-article-output]');
    const num_articles = $articles.length;
    // weird things happen when you use the same format as shopify...
    const possibly_json = $articles_container.find('[data-settings]').html();
    const json = possibly_json.replace('// <![CDATA[', '').replace('// ]]>', '');
    const {blocks} = JSON.parse(json);

    // we don't need it and it messes with our nth-child count
    $articles_container.find('script').remove();

    if (num_articles === 0 || num_articles > 3 || !blocks) { return; }

    if (num_articles === 2 && !isNaN(main_index)) {
      $articles.eq(main_index).addClass('RteStaggeredArticle--main');
    }

    if (num_articles === 3) {
      $articles.eq(2).addClass('RteStaggeredArticle--narrow');
    }

    _.each(blocks, (article_data, index) => {
      if (!(article_data.event_date_top && article_data.event_date_bottom)) { return; }

      const $event = $articles.eq(index);
      const $excerpt = $event.find('[data-excerpt]');
      const article_url = $event.find('a[href]').first().attr('href');
      const article_label = $event.find('a[aria-label]').first().attr('aria-label');
      const excerpt_text = $excerpt.html();

      $event.addClass('RteStaggeredArticle--event');
      $event.find('[data-tag]').html(window.theme.locales.event);
      $excerpt.before(`
      <a class="RteStaggeredArticle__excerpt RteStaggeredArticle__excerpt--event" aria-label="${article_label}" href="${article_url}">
        <div class="RteStaggeredArticle__date-container">
          <div class="RteStaggeredArticle__date">
            <div class="RteStaggeredArticle__date-top">${article_data.event_date_top}</div>
            <div class="RteStaggeredArticle__date-bottom">${article_data.event_date_bottom}</div>
          </div>
        </div>
        ${excerpt_text}
      </a>
      `);
      $excerpt.remove();
    });

    switch (num_articles) {
      case 1:
        $articles_container.children(':nth-child(1)').wrap('<div class="RteStaggeredArticles__featured-container"></div>');
        break;
      case 2:
        if ($articles_container.find('.RteStaggeredArticle--event').length === 1) {
          $articles_container.children(':not(.RteStaggeredArticle--event)').wrap('<div class="RteStaggeredArticles__with-event-container"></div>');
          $articles_container.children('.RteStaggeredArticle--event').wrap('<div class="RteStaggeredArticles__event-container"></div>');
        } else {
          $articles.wrap('<div class="RteStaggeredArticles__equal-container"></div>');
        }
        break;
      case 3:
        $articles_container.children(':nth-child(1)').wrap('<div class="RteStaggeredArticles__main-container"></div>');
        $articles_container.children(':nth-child(2), :nth-child(3)').wrapAll('<div class="RteStaggeredArticles__side-container"></div>');
        break;
    }

    $articles_container.addClass('RteStaggeredArticles');
    $articles_container.wrap(`
    <section class="Section Section--fixed Section--mobile-fixed Animate Animate--slide-up">
      <div class="Section__container">
      </div>
    </section>
    `);
  });
};